import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { MyEInvoiceFromIrbContainerContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice-from-irb-hdr-container.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceFromIRBHdrService extends BaseApiPublicLoginTemplateService<MyEInvoiceFromIrbContainerContainerModel, MyEInvoiceFromIrbContainerContainerModel, MyEInvoiceFromIrbContainerContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/from-irbs'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/from-irbs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/from-irbs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/from-irbs/' + BaseApiTemplateService.LOGIN_EP
    this.httpClient = http;
  }

}
